import { useQuery } from '@tanstack/react-query';
import getToolboxInfo from '../../api/toolbox';
import { formatApiError } from '../../api/common/errors';
import { getQueryAlertMessages } from './formatters/alerts';
export const keys = {
    all: ['toolbox']
};
export function useToolboxInfo() {
    return useQuery(keys.all, getToolboxInfo, {
        staleTime: Infinity,
        meta: getQueryAlertMessages(error => formatApiError(error, 'Failed to load information about the required toolbox app version'))
    });
}
